import { render, staticRenderFns } from "./FormatTextComponentForm.vue?vue&type=template&id=fb3180d2&scoped=true&"
import script from "./FormatTextComponentForm.vue?vue&type=script&lang=ts&"
export * from "./FormatTextComponentForm.vue?vue&type=script&lang=ts&"
import style0 from "./FormatTextComponentForm.vue?vue&type=style&index=0&id=fb3180d2&scoped=true&lang=css&"
import style1 from "./FormatTextComponentForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3180d2",
  null
  
)

export default component.exports